import { useState } from 'react'
import { FormModal } from './FormModal'
import { useAuth } from 'hooks/UseAuth'
import { useSelector } from 'react-redux'
import { RootState } from 'types'
import { showErrorMessageToast } from 'common/MessageToasts/ErrorMessageToast/ErrorMessageToast'
import { useObjectRef } from '../../utils/useObjectRef'
import { FormRef } from '../Form/Form'
import { ConfirmationDialog } from './ConfirmationDialog'

interface Props {
  onClose: () => void
}

export const FormModalContainer = ({ onClose }: Props) => {
  const auth = useAuth()
  const currentWorkspaceId = useSelector((state: RootState) => state.workspace.currentWorkspaceId)
  const formRef = useObjectRef<FormRef>()
  const [showLeaveConfirmation, setShowLeaveConfirmation] = useState(false)

  if (!auth || !currentWorkspaceId) {
    showErrorMessageToast('Unable to edit profile.')
  }

  const handleClose = () => {
    if (formRef.current?.isDirty()) {
      return setShowLeaveConfirmation(true)
    }
    onClose()
  }

  const handleComplete = () => {
    onClose()
  }

  return (
    <>
      <FormModal
        ref={formRef}
        memberId={auth?.id}
        workspaceId={currentWorkspaceId}
        onClose={handleClose}
        onComplete={handleComplete}
      />
      {showLeaveConfirmation && (
        <ConfirmationDialog onConfirm={onClose} onCancel={() => setShowLeaveConfirmation(false)} />
      )}
    </>
  )
}
